export const OFFERS_NEW_PATH = '/offers/new';
export const OFFERS_SENT_PATH = '/offers/sent';
